module.exports = __webpack_public_path__ + "static/media/SuisseIntl-SemiBold-WebS.d5136d68.woff";